import { useEffect, useState } from "react";
import { Input, DatePicker, Button, Form, Row, Col, Select, message, notification, Spin, Tooltip, Modal, Checkbox } from "antd";
import Paragraph from "antd/lib/typography/Paragraph";
import { ClearOutlined, PrinterOutlined, SearchOutlined } from "@ant-design/icons";
import TablaInfracciones from "./TablaInfracciones";
import locale from "antd/lib/date-picker/locale/es_ES";
import useInfraccionesAPI, { Infraccion, InfraccionesCallCenter, InfraccionesCallCenterRequest } from "../../infracciones/hooks/useInfraccionesAPI";
import ModalImpresion from "./ModalImpresion";
import useUnidadesProduccionAPI, { UnidadProduccion } from "../../unidades-produccion/useUnidadesProduccionAPI";

const { RangePicker } = DatePicker;

export default () => {
  const infraccionesApi = useInfraccionesAPI();
  const unidadProducccionApi = useUnidadesProduccionAPI();
  const [form] = Form.useForm<InfraccionesCallCenterRequest>();
  //const [tableData, setTableData] = useState<Infraccion[]>([]);
  const [tableData, setTableData] = useState<InfraccionesCallCenter[]>([]);
  const [isModalPrintVisible, setIsModalPrintVisible] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [opcionesUnidadesProduccion, setOpcionesUnidadesProduccion] = useState<UnidadProduccion[]>();
  const [spinnerLoading, setSpinnerLoading] = useState<boolean>(false);
  const [selectedRowsList, setSelectedRowsList] = useState<number[]>([]);
  const [isModalRegenerarVisible, setIsModalRegenerarVisible] = useState(false);
  const [diasVencimiento, setDiasVencimiento] = useState(localStorage.getItem('diasVencimiento') || '0');
  const [mantenerValores, setMantenerValores] = useState(false);
  const [descargarZip, setDescargarZip] = useState(true);

  const handleRegenerarClick = () => {
    if (selectedRowsList.length === 0) {
      notification.warning({ message: 'Seleccione al menos un acta para regenerar' });
      return;
    }
    setIsModalRegenerarVisible(true);
  };

  const handleConfirmRegenerar = async () => {
    setIsModalRegenerarVisible(false);
    setSpinnerLoading(true);
    localStorage.setItem('diasVencimiento', diasVencimiento);

    try {
      if (selectedRowsList.length === 1 && descargarZip) {
         // Logica individual original
           const response = await infraccionesApi.downloadUpdateActa(selectedRowsList[0], Number(diasVencimiento), mantenerValores);
           if (response.data) {
             window.open(response.data, '_blank');
             notification.success({ message: 'Acta regenerada y PDF descargado' });
           } else if (response.error) {
             notification.error({ message: 'Error al regenerar el acta.' });
           } else {
             notification.warning({ message: 'Acta regenerada correctamente, pero no se pudo descargar el PDF automáticamente.' });
           }
      } else {
         // Logica masiva
         const response = await infraccionesApi.regenerarLoteMasivo(selectedRowsList, Number(diasVencimiento), mantenerValores);
         if (!response.error) {
           notification.success({ message: 'Actas regeneradas correctamente' });
         } else {
           notification.error({ message: 'No se pudo realizar la regeneración masiva' });
         }
      }
    } catch (error) {
      notification.error({ message: 'Error inesperado durante la regeneración' });
    } finally {
      setSpinnerLoading(false);
    }
  };

  useEffect(()=>{
    const cargarSelectUnidadProduccion = async () => {
      await unidadProducccionApi.list({})
      .then((data) => {
        setOpcionesUnidadesProduccion(data.data?.value);
      })
      .catch((error) => {
        notification.error({message:'No se pueden cargar las unidades de producción...'});
      });
    }
    form.setFieldValue('Estado', 4);
    form.setFieldValue('estadoPago', 0);
    cargarSelectUnidadProduccion();
  }, [])


  const getDataDniCuit = (dniOrCuit:string) => {
    var data = dniOrCuit.replace(/[-.]/g,'');    
    return data;
  };

  const getDataFechas = (fechas:any) => {
    var fechaDesde = fechas[0].startOf('day').toISOString();
    var fechaHasta = fechas[1].endOf('day').toISOString();
    //var fechaFilter = `FechaHora ge ${fechaDesde/*.utc()*/.startOf("day").toISOString()} and FechaHora le ${fechaHasta/*.utc()*/.endOf("day").toISOString()}`;
    return [fechaDesde, fechaHasta];
  };

  const getDataNroActa = (nroacta:string) => {
    var data = nroacta.replace(/\D/g,'');
    var dataNro = parseInt(data)
    var dataFilter = `Id eq ${dataNro}`;

    return dataFilter;
  }

  const handleSearch = async () => {
  
    form.validateFields().then(async values => {
        setSpinnerLoading(true);

        values.DniCuit = values.DniCuit ? getDataDniCuit(values.DniCuit ?? '') : undefined;
        values.FechaInfraccionDesde = values.fechaRango ? getDataFechas(values.fechaRango)[0] : undefined;
        values.FechaInfraccionHasta = values.fechaRango ? getDataFechas(values.fechaRango)[1] : undefined;

        var req = form.getFieldsValue()
        var invalidReq = Object.values(req).every(value => value === undefined || value === null);
        
        if(invalidReq){
          notification.info({message: 'Debe indicar al menos un parametro para filtrar...'});
          setSpinnerLoading(false)
        }else{
          const response = await infraccionesApi.getInfraccionesCallCenter(values)
            .finally(() => setSpinnerLoading(false));
            setTableData(response ?? []);
        }
    });
    
  };

  const handlePrint = () => {
      setIsModalPrintVisible(true);
  };

  const handleGeneratePDF = () => {
      setIsModalPrintVisible(false);
      generarCSV(); // Generar el PDF con las columnas seleccionadas
  };

  const generarCSV = () => {
    const headers = "CUIT/CUIL;Nomb. completo;Nro acta;Patente;Fecha inf.;Venc. pago vol.;Venc. total;Imp pago total;Imp gastos adm.;Desc. pago vol;Total a pagar\n";
    const rows = generarRegistrosCsv();

    // ❌ ENFOQUE ANTERIOR (problemático con datasets grandes):
    // Se construía el CSV como un Data URL usando encodeURI().
    // El problema es que los navegadores limitan los Data URLs a ~2MB.
    // Con ~80k filas ese límite se supera, truncando el archivo (solo ~6000 filas y la última cortada).
    //
    // const csvContent = "data:text/csv;charset=utf-8," + headers + rows;
    // link.href = encodeURI(csvContent);

    // ✅ ENFOQUE NUEVO: Blob + createObjectURL
    // Blob no tiene límite de tamaño (usa memoria del proceso del navegador).
    // createObjectURL genera una URL local temporal que apunta directamente al Blob en memoria.
    // El \uFEFF al inicio es el BOM UTF-8: hace que Excel abra tildes y ñ correctamente sin importar.
    const blob = new Blob(["\uFEFF" + headers + rows], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Infracciones impagas.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url); // Liberar la URL temporal de memoria una vez descargado
  };

  const generarRegistrosCsv = () => {
    var row: string[] = [];
    tableData.forEach((data:any) =>{
      const dataColumn = [];
      const importePagoTotal = (data.valorUF ?? 0) * (data.cotizacionUF ?? 0);
      const importeDescuento = (importePagoTotal * (data.porcentajeDescuentoPagoVoluntario ?? 0) / 100);
      const importePagoVoluntario = (importePagoTotal - importeDescuento);
      const fechaVencimiento = normalizarFecha(data.vencimientoPagoVountario??'');
      const fechaActual = normalizarFecha(new Date());
      const pagoVoluntarioVencido = fechaVencimiento <= fechaActual;
      const totalAPagar = pagoVoluntarioVencido ? importePagoTotal + (data.gastosAdministrativos??0) : importePagoVoluntario + (data.gastosAdministrativos??0);

      dataColumn.push(data.titular.cuilTitular);
      dataColumn.push(data.titular.nombreCompletoTitular);
      dataColumn.push(data.nroTramite);
      dataColumn.push(data.patente);
      dataColumn.push(new Date(data.fechaInfraccion??'').toLocaleDateString(locale.dateFormat));
      dataColumn.push(new Date(data.vencimientoPagoVountario??'').toLocaleDateString(locale.dateFormat));
      dataColumn.push(new Date(data.fecha2doVencimiento??'').toLocaleDateString(locale.dateFormat));
      //dataColumn.push(normalizarMoneda(importePagoVoluntario.toString()));
      dataColumn.push(normalizarMoneda(importePagoTotal.toString()));
      dataColumn.push(normalizarMoneda((data.gastosAdministrativos??'').toString()));
      dataColumn.push(normalizarMoneda(importeDescuento.toString())+(pagoVoluntarioVencido?'(vencido)':''));
      dataColumn.push(normalizarMoneda(totalAPagar.toString()));

      row.push(`${dataColumn.join(';')}`);
    })
    
    return row.join('\n');
  };

  const normalizarFecha = (fechaString:any) => {
      let fecha = new Date(fechaString);
      fecha.setHours(0, 0, 0, 0);
      return fecha;
  };

  const normalizarMoneda = (valorString:string) => {
      // Reemplazar la coma por punto y convertir a número
      const valorNumerico = parseFloat(valorString.replace(',', '.'));

      // Formatear el número como moneda
      return valorNumerico.toLocaleString('es-AR', {
          style: 'currency',
          currency: 'ARS',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
      });
  };

  return (
    <>
    <Form form={form} layout="vertical" style={{width: '100%', maxWidth: ''}} onFinish={handleSearch} title="Busqueda de infracciones">
      <Row gutter={[20, 20]}>
        <Col xs={36} sm={12} md={8} lg={6}>
          <Form.Item label="Patente" name="patente">
            <Input placeholder="Ingrese patente"/>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
          <Form.Item label="DNI o CUIT" name="dniCuit" tooltip="Puede ingresar con o sin guiones o puntos">
            <Input placeholder="Ejm: 12-112... o 11.22... o 12112223334" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
          <Form.Item label="Apellido y apellido" name="apellidoNombre">
            <Input placeholder="Apellido o nombre" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
          <Form.Item label="Fecha de infracción" name="fechaRango">
            <RangePicker style={{ width: "100%" }} locale={locale} />
          </Form.Item>
        </Col>
        
      </Row>
        
      <Row gutter={[20, 20]}>
        <Col xs={36} sm={12} md={8} lg={6}>
            <Form.Item label="Estado pago" name="estadoPago">
                <Select defaultValue={null}>
                    <Select.Option value={null}>Todas</Select.Option>
                    <Select.Option value={2}>Pagas</Select.Option>
                    <Select.Option value={0}>Impagas</Select.Option>
                </Select>
            </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
          <Form.Item label="Núm. Acta" name="nroTramite">
            <Input placeholder="Ejm: AB00123 o 123" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
          <Form.Item label="Unidad de producción" name="unidadProduccion">
                <Select defaultValue={null}>
                <Select.Option value={null}>Todas</Select.Option>
                  {opcionesUnidadesProduccion?.map((opcion) => (
                    <Select.Option key={opcion.Id} value={opcion.Id}>
                      {opcion.Nombre}
                    </Select.Option>
                  ))}
                </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
          <Form.Item label="Vencimiento" name="vencimiento">
            <Select defaultValue={null} placeholder="Seleccione">
              <Select.Option value={null}>Todas</Select.Option>
              <Select.Option value={1}>Vigentes</Select.Option>
              <Select.Option value={2}>Pago voluntario vencido</Select.Option>
              <Select.Option value={3}>Pago total vencido</Select.Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[20, 20]}>
        <Col xs={36} sm={12} md={8} lg={6}>
            <Form.Item label="Estado acta" name="Estado">
                <Select defaultValue={null}>
                    <Select.Option value={null}>Todas</Select.Option>
                    <Select.Option value={4}>Impresas/generadas</Select.Option>
                    <Select.Option value={5}>Descartadas</Select.Option>
                </Select>
            </Form.Item>
        </Col>
        <Col xs={36} sm={12} md={8} lg={6}>
            <Form.Item label="Tipo persona" name="tipoPersona">
                <Select defaultValue={null}>
                    <Select.Option value={null}>Todas</Select.Option>
                    <Select.Option value={2}>Físicas</Select.Option>
                    <Select.Option value={1}>Empresas</Select.Option>
                </Select>
            </Form.Item>
        </Col>
      </Row>

      <Row justify={'space-between'} align={'middle'}>
        <Col>
            <Button type="primary" icon={<SearchOutlined />} onClick={handleSearch} htmlType="submit" onKeyDown={(e)=>{if(e.key == 'Enter')handleSearch();}}>
                Buscar infracciones
            </Button>
            <Button type="primary" style={{marginLeft:'1em'}} icon={<ClearOutlined />} onClick={() => form.resetFields()}>
                Limpiar filtros
            </Button>
            <Button type="primary" style={{marginLeft:'1em'}} onClick={handleRegenerarClick}>
                Regenerar Infracciones
            </Button>
        </Col>
        <Col>
            <Button type="ghost" icon={<PrinterOutlined />} onClick={handlePrint}>
                Descargar listado
            </Button>
        </Col>
      </Row>
    </Form>

    <TablaInfracciones tableData={tableData} spinnerLoading={spinnerLoading} selectedRowsList={selectedRowsList} setSelectedRows={setSelectedRowsList}></TablaInfracciones>
    
    <ModalImpresion
      visible={isModalPrintVisible}
      //columns={[{title:'Prueba', key:1}]}
      selectedColumns={selectedColumns}
      onConfirm={setSelectedColumns}
      onCancel={()=>setIsModalPrintVisible(false)}
      okButton={handleGeneratePDF}
      />

    <Modal
      title="Opciones de Regeneración"
      open={isModalRegenerarVisible}
      onOk={handleConfirmRegenerar}
      onCancel={() => setIsModalRegenerarVisible(false)}
      okText="Confirmar"
      cancelText="Cancelar"
      okType="primary"
    >
      <Paragraph>Está por regenerar {selectedRowsList.length} acta(s). ¿Desea continuar?</Paragraph>
      <div style={{ marginBottom: '1em' }}>
        <Paragraph>Días de vencimiento: </Paragraph>
        <Input 
          onChange={(e) => setDiasVencimiento(e.target.value)} 
          value={diasVencimiento} 
          size="small" 
          style={{ width: "30%" }} 
          type="number" 
        />
      </div>
      <div style={{ marginBottom: '1em' }}>
        <Checkbox 
          checked={mantenerValores} 
          onChange={(e) => setMantenerValores(e.target.checked)}
        >
          ¿Mantener valores actuales?
        </Checkbox>
      </div>
      <div>
        <Checkbox 
          checked={descargarZip} 
          onChange={(e) => setDescargarZip(e.target.checked)}
        >
          ¿Descargar archivo resultante (PDF / CSV)?
        </Checkbox>
      </div>
    </Modal>
    </>
  );
};

